export default {
  portugues: {
    title: "Melhore o seu plano",
    subtitle1: "Transforme o valor restante da sua assinatura atual ",
    subtitle2: "em desconto para fazer upgrade e melhorar ainda mais sua expêriencia!",
    subtitleOrder1: "Você possui uma assinatura",
    subtitleOrder2: "válida até",
    subtitle3:
      "Este valor é calculado pelo saldo de dias não utilizados da sua assinatura atual.",
    subtitle4:
      "Ao fazer o upgrade, sua data de início da nova assinatura será hoje.",
    subtitle5: "PARABÉNS!",
    subtitle6: "Você já é um assinante Gold.",

    // Assinante ativo NÃO-Gold (Plus/Basic): incentivo de upgrade/renovação com saldo real.
    activeUpgradePrefix: "Você tem um",
    activeUpgradeBalanceLabel: "saldo de",
    activeUpgradeSuffix: "para fazer seu upgrade ou renovação",

    // Estado Gold com MAIS de 30 dias para vencer: tudo bloqueado (parabéns + validade).
    goldGt30Title: "Parabéns, você já é um assinante Gold!",
    goldGt30Validity: "Sua assinatura é válida até",

    // Estado Gold com 30 dias ou MENOS para vencer: renovação liberada (título + saldo + validade).
    goldLe30Title: "Renove o seu plano Gold",
    goldLe30Prefix: "Você tem um",
    goldLe30BalanceLabel: "saldo de",
    goldLe30Middle: "para renovar sua assinatura com vencimento em",
  },
  ingles: {
    title: "Upgrade your subscription",
    subtitle1: "Turn the remaining value of your current subscription",
    subtitle2: "into a discount to upgrade and further enhance your experience!",
    subtitleOrder1: "You have a subscription",
    subtitleOrder2: "valid until",
    subtitle3:
      "This amount is calculated based on the balance of unused days on your current subscription.",
    subtitle4:
      "When you upgrade, your new subscription start date will be today.",
    subtitle5: "CONGRATULATIONS!",
    subtitle6: "You are already a Gold subscriber.",

    // Active NON-Gold subscriber (Plus/Basic): upgrade/renewal incentive with real balance.
    activeUpgradePrefix: "You have a",
    activeUpgradeBalanceLabel: "balance of",
    activeUpgradeSuffix: "to upgrade or renew your subscription",

    // Gold state with MORE than 30 days to expire: everything locked (congrats + validity).
    goldGt30Title: "Congratulations, you are already a Gold subscriber!",
    goldGt30Validity: "Your subscription is valid until",

    // Gold state with 30 days or LESS to expire: renewal available (title + balance + validity).
    goldLe30Title: "Renew your Gold plan",
    goldLe30Prefix: "You have a",
    goldLe30BalanceLabel: "balance of",
    goldLe30Middle: "to renew your subscription expiring on",
  },
};
